export const isDisable = (
  mapping,
  mappingIndex,
  parameterIndex,
  role,
  isDataRejectedByProcessor,
  entireBatchRejectedByPro,
  parametersData,
  entireBatchRejectedByVali,
  reProcessEntireBatch,
  reProcess,
  isDataRejectedByValidator,
  reValidate
) => {
  let isDisable = false; // initially its false
  if (role === "preProcessor") {
    if (
      isDataRejectedByProcessor === true && // getting true when data is rejected
      entireBatchRejectedByPro === false // getting true when entire batch rejected
    ) {
      isDisable =
        mapping?.processorCellRejection?.isRejected === true ||
        parametersData[parameterIndex]?.processorRowRejection?.isRejected ===
          true
          ? false
          : true;
    } else if (
      isDataRejectedByProcessor === true && // getting both flags true when entire batch rejected
      entireBatchRejectedByPro === true
    ) {
      isDisable = false;
    }
    if (
      parametersData[parameterIndex].enableCellsForNewColumn === true &&
      mapping?.newColumn === true
    ) {
      isDisable = false;
    }
  }

  if (role === "processor") {
    if (!entireBatchRejectedByVali) {
      if (!reProcessEntireBatch) {
        if (reProcess) {
          isDisable = !(
            mapping?.processorCellRejection?.isResolved === true ||
            parametersData[parameterIndex]?.processorRowRejection?.isResolved
          );
        }
        if (isDataRejectedByValidator) {
          isDisable =
            mapping?.validatorCellRejection?.isRejected ||
            parametersData[parameterIndex]?.validatorRowRejection?.isRejected
              ? false
              : true;
        }
        if (reProcess && isDataRejectedByValidator) {
          // when data rejected by validator and processor and then resolved by pre processor at that time for both rejection we need to enable field
          let disableForProResolve = !(
            mapping?.processorCellRejection?.isResolved === true ||
            parametersData[parameterIndex]?.processorRowRejection?.isResolved
          );
          let disableForValidatorRejection =
            mapping?.validatorCellRejection?.isRejected ||
            parametersData[parameterIndex]?.validatorRowRejection?.isRejected
              ? false
              : true;
          if (
            disableForProResolve === false &&
            disableForValidatorRejection === true
          ) {
            isDisable = false;
          }
        }

        if (
          parametersData[parameterIndex].enableCellsForNewColumn === true &&
          mapping?.newColumn === true
        ) {
          isDisable = false;
        }
      }
    }
    if (role === "validator") {
      if (reValidate) {
        isDisable = !(
          mapping?.validatorCellRejection?.isResolved === true ||
          parametersData[parameterIndex]?.validatorRowRejection?.isResolved
        );
      }
    }
  }
  return isDisable;
};
